import React from 'react';
import { Globe } from 'lucide-react';
export function TopBar() {
  return <div className="bg-au-navy text-white text-xs font-medium py-2 px-4 md:px-8 flex justify-between items-center" data-id="element-267">
      <div data-id="element-268">
        <a href="#" className="hover:text-au-gold transition-colors" data-id="element-269">
          About the African Union
        </a>
      </div>
      <div className="flex items-center space-x-3" data-id="element-270">
        <Globe size={14} className="text-gray-300" data-id="element-271" />
        <div className="flex items-center space-x-2" data-id="element-272">
          <button className="bg-au-gold text-au-navy px-1.5 py-0.5 rounded-sm font-bold" data-id="element-273">
            EN
          </button>
          <span className="text-gray-500" data-id="element-274">|</span>
          <button className="hover:text-au-gold transition-colors" data-id="element-275">FR</button>
          <span className="text-gray-500" data-id="element-276">|</span>
          <button className="hover:text-au-gold transition-colors" data-id="element-277">ES</button>
          <span className="text-gray-500" data-id="element-278">|</span>
          <button className="hover:text-au-gold transition-colors" data-id="element-279">AR</button>
          <span className="text-gray-500" data-id="element-280">|</span>
          <button className="hover:text-au-gold transition-colors" data-id="element-281">PT</button>
        </div>
      </div>
    </div>;
}